// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from '../../gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetIntercomConfigQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetIntercomConfigQuery = {
  readonly __typename: 'Query';
  readonly intercomConfig: {
    readonly __typename: 'IntercomConfig';
    readonly intercomEnabled: boolean;
    readonly intercomUrl: string;
    readonly agent: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly userFid: string;
      readonly intercomEmail: string | null;
      readonly intercomKey: string | null;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly legal: string | null;
      };
      readonly organization: {
        readonly __typename: 'Organization';
        readonly orgNum: string;
        readonly name: string;
      };
    } | null;
  };
};

export const GetIntercomConfigDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetIntercomConfig' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intercomConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intercomEnabled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'intercomUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'structuredName' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'full' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'legal' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userFid' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intercomEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intercomKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orgNum' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetIntercomConfigQuery,
  GetIntercomConfigQueryVariables
>;
